var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('loader',{attrs:{"loading":_vm.isLoading}}),(!_vm.isLoading)?_vm._m(0):_vm._e(),_c('b-card-footer',{staticClass:"text-right"},[(!_vm.isLoading)?_vm._m(1):_vm._e()],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"no-gutters":""}},[_vm._t("default")],2)
},function (){var _vm=this,_c=_vm._self._c;return _c('b-row',[_vm._t("footer")],2)
}]

export { render, staticRenderFns }